import Loadable from 'react-loadable';

export default Loadable({
	loader: () =>
		import(/* webpackChunkName: "@atlaskit-internal_conversation-assistant" */ './main'),
	loading: () => null,
});
